<template>
  <Creative
    :id="getCreativeId"
    :title="`Review Creative`"
  />
</template>

<script>
import Creative from './Creative.vue'

export default {
  name: 'ScreenCreative',  

  components: {
    Creative
  },  

  computed:{
    getCreativeId() {
      return this.$route.params.id
    }
  },

  methods: {    
  }
}
</script>